import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EnvironmentService } from './environment.service';
import { Store } from '@ngxs/store';
import { RDMClientService } from '../services/rdm-client.service';
import {
  RefValue,
  StandardPagableResponse,
} from '../interfaces/rdm-client.interface';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class RiskManagementTableService {
  rdmList!: RefValue[];
  constructor(
    private http: HttpClient,
    public store: Store,
    private rdmService: RDMClientService,
    private env: EnvironmentService
  ) {
    this.env.getEnvironment();
  }

  getRiskMgmtTblData(
    referenceCode?: any,
    importer?: any,
    agentCode?: any,
    submitter?: any,
    validFrom?: any,
    inspectionAction?: any,
    validTo?: any,
    page?: any,
    size?: any,
    sort?: any,
    referanceType?: any
  ) {
    const envValue: any = this.env.getEnvironment();
    const params = new HttpParams()
      .set('referenceCode', referenceCode)
      .set('importer', importer)
      .set('agentCode', agentCode)
      .set('submitter', submitter)
      .set('validFrom', validFrom)
      .set('inspectionAction', inspectionAction)
      .set('validTo', validTo)
      .set('referanceType', referanceType)
      .set('size', size)
      .set('page', page);
    return this.http.get(
      envValue.wso2amEndPoint +
        '/intelligenceman' +
        envValue.wso2amApiVersion +
        '/api/v1/riskAss/search',
      { params: params }
    );
  }

  downloadAttachment(url: unknown) {
    const envValue: any = this.env.getEnvironment();
    return this.http.get(envValue.wso2amEndPoint + url, {
      responseType: 'blob',
    });
  }

  tarriffRdmData(): Observable<unknown> {
    const envValue: any = this.env.getEnvironment();
    return this.http.get(
      envValue.wso2amEndPoint +
        '/tariff' +
        envValue.wso2amApiVersion +
        '/api/v1/getTariffCode'
    );
  }

  productRdmData(): Observable<unknown> {
    const envValue: any = this.env.getEnvironment();
    return this.http.get(
      envValue.wso2amEndPoint +
        '/tariff' +
        envValue.wso2amApiVersion +
        '/api/v1/tariff/product/search'
    );
  }

  getRdmParentRefType(parentRefValue: any): Observable<unknown> {
    const envValue: any = this.env.getEnvironment();
    const params = new HttpParams().set('parent', parentRefValue);
    return this.http.get<StandardPagableResponse>(
      envValue.wso2amEndPoint +
        '/rdm' +
        envValue.wso2amApiVersion +
        '/api/v1/types/parentRefvalue',
      { params: params }
    );
  }

  getRiskAssesmentDetails(referenceCode: any): Observable<any> {
    const envValue = this.env.getEnvironment();
    const params = new HttpParams()
      .set('referanceType', 'DECLARATION')
      .set('sort', 'referenceCode,desc')
      .set('size', '10')
      .set('page', '0')
      .set('validTo', '')
      .set('inspectionAction', '')
      .set('validFrom', '')
      .set('submitter', '')
      .set('agentCode', '')
      .set('importer', '')
      .set('referenceCode', referenceCode);
    return this.http.get(
      envValue.wso2amEndPoint +
        '/intelligenceman' +
        envValue.wso2amApiVersion +
        '/api/v1/riskAss/search',
      { params: params }
    );
  }

  longRoutedContainers(manifestId: number): Observable<unknown> {
    const envValue: any = this.env.getEnvironment();
    return this.http.get(
      envValue.wso2amEndPoint +
        '/intelligenceman' +
        envValue.wso2amApiVersion +
        '/api/v1/risks/longRoutedContainers/' +
        manifestId
    );
  }

  containerRoute(
    declarationId: number,
    containerNo: string
  ): Observable<unknown> {
    const envValue: any = this.env.getEnvironment();
    return this.http.get(
      envValue.wso2amEndPoint +
        '/manifest' +
        envValue.wso2amApiVersion +
        '/api/v1/transportContractDocuments/containerJourney/' +
        declarationId +
        '/' +
        containerNo
    );
  }

  getRiskInfoForProfileCode(profileCode: number): Observable<unknown> {
    const envValue: any = this.env.getEnvironment();
    return this.http.get(
      envValue.wso2amEndPoint +
        '/intelligenceman' +
        envValue.wso2amApiVersion +
        '/api/v1/risk/information/getRiskInformationForProfileCode/' +
        profileCode
    );
  }

  getExternalSourceRiskInformation(
    riskInformationId: number
  ): Observable<unknown> {
    const envValue: any = this.env.getEnvironment();
    return this.http.get(
      envValue.wso2amEndPoint +
        '/intelligenceman' +
        envValue.wso2amApiVersion +
        '/api/v1/risk/information/getExternalSourceRiskInformation/' +
        riskInformationId
    );
  }

  searchExternalNews(
    source: string,
    page?: number,
    size?: number,
    sort?: string
  ): Observable<any> {
    const envValue = this.env.getEnvironment();
    const params = new HttpParams().set('size', size + '').set('page', page + '');
    return this.http.get(
      envValue.wso2amEndPoint +
        '/intelligenceman' +
        envValue.wso2amApiVersion +
        '/api/v1/risk/information/searchExternalNews/' +
        source,
      { params: params }
    );
  }
}
